import {  getAnalytics } from './configuration' ;

const logger = Logger.get( 'firebase/analytics' );

class CreateAnalytics {
    triggers = [] ;
    analytics = null ;
    
    async logEvent( ...args ){
        try{
            this.triggers.push( args ) ;
            if( !this.analytics )this.analytics = await getAnalytics() ;
            this._triggerLogs();
        }
        catch( e ){ logger.log( e ) };
    }

    _triggerLogs(){
        for( let triggerArgs of this.triggers ){
            this.analytics.logEvent( ...triggerArgs ) ;
        }
        this.triggers = [];
    }

}

const analytics = new CreateAnalytics() ;

export default analytics ;
